import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { CATEGORIES } from "@/constants/categories";

export const CategoryGrid = () => {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  return (
    <section className="container-z py-20" aria-labelledby="cats-title" data-testid="categories-section">
      <div className="mb-10 max-w-2xl">
        <h2 id="cats-title" className="text-3xl font-bold tracking-tight sm:text-4xl">{t("cats.title")}</h2>
        <p className="mt-3 text-base text-navy/65">{t("cats.sub")}</p>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        {CATEGORIES.map((c, i) => {
          const Icon = c.icon;
          return (
            <button
              key={c.slug}
              data-testid={`category-card-${c.slug}`}
              onClick={() => (c.slug === "docs" ? navigate("/docs") : navigate("/solve", { state: { category: c.slug, prefill: lang === "hi" ? c.sampleHi : c.sampleEn } }))}
              className="card-lift group flex flex-col items-start gap-4 rounded-2xl border border-navy/10 bg-white p-5 text-left animate-fade-up"
              style={{ animationDelay: `${i * 40}ms` }}
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-cyan-soft text-brand group-hover:bg-brand group-hover:text-white" style={{ transition: "background-color .2s, color .2s" }}>
                <Icon className="h-5 w-5" />
              </span>
              <span className="flex w-full items-end justify-between gap-2 text-sm font-semibold text-navy">
                {lang === "hi" ? c.hi : c.en}
                <ArrowUpRight className="h-4 w-4 shrink-0 text-navy/30 group-hover:text-brand" />
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
};
